import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { Configurations } from '../../../Utils/Configurations';
import './Unlisted-Content.scss';

// A API hoje devolve só o booleano `ativo` (sem os estados Pendente/Indisponível
// separados nem `removidoEm`). Enquanto isso não muda, Pendente x Indisponível colapsam
// em um único badge "Indisponível".
const badgePorStatus = (item) => {
    if (item.removidoEm) return { texto: 'Removido', className: 'badge badge-light text-muted border' };
    if (item.ativo) return { texto: 'Disponível', className: 'badge badge-success' };
    return { texto: 'Indisponível', className: 'badge badge-dark' };
};

const UnlistedContent = ({ history }) => {
    const configurations = new Configurations();

    const [conteudos, setConteudos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [paginaAtual, setPaginaAtual] = useState(1);
    const [totalPaginas, setTotalPaginas] = useState(0);
    const [limite] = useState(10);

    const carregarConteudos = (pagina) => {
        setLoading(true);
        setHasError(false);
        axios.get(`${configurations.apiBasePath}/conteudo/nao-listados?pagina=${pagina}&limite=${limite}`)
            .then(response => {
                setConteudos(response.data.conteudos || []);
                setTotalPaginas((response.data.paginacao && response.data.paginacao.totalPaginas) || 0);
                setPaginaAtual(pagina);
            })
            .catch(err => {
                console.error('Erro ao carregar conteúdos não listados', err);
                setHasError(true);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        carregarConteudos(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onPageChange = (pageIndex) => carregarConteudos(pageIndex + 1);

    const editarConteudo = (id) => history.push(`/nao-listados/${id}`);

    const columns = [
        {
            Header: 'Título',
            accessor: 'titulo',
            className: 'text-left',
        },
        {
            Header: 'Data de criação',
            accessor: 'dtCriacao',
            className: 'text-center pointer',
            width: 150,
            Cell: row => (row.value ? moment(row.value).format('DD/MM/YYYY') : '-'),
        },
        {
            Header: 'Status',
            className: 'text-center pointer',
            width: 140,
            Cell: row => {
                const badge = badgePorStatus(row.original);
                return <span className={badge.className}>{badge.texto}</span>;
            },
        },
        {
            Header: 'Ações',
            className: 'text-center',
            width: 120,
            sortable: false,
            Cell: row => (
                <button className="btn btn-sm btn-outline-primary" onClick={() => editarConteudo(row.original._id)}>
                    Editar
                </button>
            ),
        },
    ];

    return (
        <div className="unlisted-content-container">
            <div className="row align-items-center mb-3">
                <div className="col-12 col-lg-8 text-center text-lg-left">
                    <h2 className="d-none d-lg-block">Conteúdos Não Listados</h2>
                    <h3 className="d-lg-none">Conteúdos Não Listados</h3>
                </div>
                <div className="col-12 col-lg-4 text-center text-lg-right">
                    <button className="btn btn-outline-success" onClick={() => history.push('/nao-listados/novo')}>
                        Novo Conteúdo Não Listado
                    </button>
                </div>
            </div>

            {hasError ? (
                <div className="alert alert-danger text-center m-3">
                    Não foi possível carregar os conteúdos não listados.
                </div>
            ) : (
                <div className="card">
                    <div className="card-body p-0">
                        <ReactTable
                            data={conteudos}
                            columns={columns}
                            manual
                            pages={totalPaginas}
                            page={paginaAtual - 1}
                            pageSize={limite}
                            onPageChange={onPageChange}
                            showPageSizeOptions={false}
                            className="-striped -highlight"
                            headerClassName="ebs-table-header"
                            previousText="Anterior"
                            nextText="Próximo"
                            loadingText="Carregando..."
                            noDataText="Não há conteúdos não listados cadastrados."
                            pageText="Página"
                            ofText="de"
                            rowsText="linhas"
                            loading={loading}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default withRouter(UnlistedContent);
